import React from 'react';

import DataDipNode from 'src/presentation/components/pages/ivr/components/nodes/DataDipNode';
import ExitNode from 'src/presentation/components/pages/ivr/components/nodes/ExitNode';
import ForwardNode from 'src/presentation/components/pages/ivr/components/nodes/ForwardNode';
import Http2Node from 'src/presentation/components/pages/ivr/components/nodes/Http2Node';
import KeypadInputNode from 'src/presentation/components/pages/ivr/components/nodes/KeypadInputNode';
import MenuNode from 'src/presentation/components/pages/ivr/components/nodes/MenuNode';
import MessageNode from 'src/presentation/components/pages/ivr/components/nodes/MessageNode';
import NODE_TYPES from 'src/models/Ivrs/NodeTypes';
import NumberMatchNode from 'src/presentation/components/pages/ivr/components/nodes/NumberMatchNode';
import VoiceAutomationNode from 'src/presentation/components/pages/ivr/components/nodes/VoiceAutomationNode';
import ScheduleNode from 'src/presentation/components/pages/ivr/components/nodes/ScheduleNode';
import SmsNode from 'src/presentation/components/pages/ivr/components/nodes/SmsNode';
import StartNode from 'src/presentation/components/pages/ivr/components/nodes/StartNode';
import TemporarySplitNode from 'src/presentation/components/pages/ivr/components/nodes/TemporarySplitNode';
import VariableMatchNode from 'src/presentation/components/pages/ivr/components/nodes/VariableMatchNode';
import VariableNode from 'src/presentation/components/pages/ivr/components/nodes/VariableNode';
import VoicemailNode from 'src/presentation/components/pages/ivr/components/nodes/VoicemailNode';
import GenericNode from 'src/presentation/components/pages/ivr/components/nodes/GenericNode';
import { CreateNewOptionLabel } from 'src/presentation/components/pages/ivr/layouts/IvrLayout';
import { DAYS_OF_THE_WEEK } from 'src/presentation/components/pages/shared/constants/dateTimeConstants';
import { MessageType } from 'src/models/Ivrs/Nodes/message';
import { ScheduleType } from 'src/models/Ivrs/Nodes/ScheduleNodeDef';
import AutomationHandoffNode from 'src/presentation/components/pages/ivr/components/nodes/AutomationHandoffNode';

export const SIDE_PANEL_WIDTH = '365px';
export const IVR_TREE_TOP_MARGIN = '50px';

export const NODE_LIST_ID = 'NODE_LIST';

export enum SIDE_PANEL_ROW_TYPES {
  ERROR_ROW = -1,
  NOT_MATCH_ROW = -2,
}

type OPTIONS_PROPS = { value: string; label: string }[];

export type NodeProps = {
  attr: string;
  onSelectNode: Function;
  nodeList?: OPTIONS_PROPS;
  readOnly?: boolean;
  disabled: boolean;
  selectedOptionIndex?: number;
};

export const FILTER_NODES_OPTIONS = {
  allNodes: {
    label: 'All Nodes',
    value: 'all_nodes',
  },
  errors: {
    label: 'Errors',
    value: 'errors',
  },
};

const NodeComponents = Object.freeze({
  [NODE_TYPES.IVR_NODE_DIAL]: ExitNode,
  [NODE_TYPES.IVR_NODE_FORWARD]: ForwardNode,
  [NODE_TYPES.IVR_NODE_HTTP]: DataDipNode,
  [NODE_TYPES.IVR_NODE_HTTP2]: Http2Node,
  [NODE_TYPES.IVR_NODE_INPUT]: KeypadInputNode,
  [NODE_TYPES.IVR_NODE_MENU]: MenuNode,
  [NODE_TYPES.IVR_NODE_MESSAGE]: MessageNode,
  [NODE_TYPES.IVR_NODE_NUMBER_MATCH]: NumberMatchNode,
  [NODE_TYPES.IVR_NODE_SCHEDULE_TEMPORARY_SPLIT]: TemporarySplitNode,
  [NODE_TYPES.IVR_NODE_SCHEDULE]: ScheduleNode,
  [NODE_TYPES.IVR_NODE_SMS]: SmsNode,
  [NODE_TYPES.IVR_NODE_VARIABLE_MATCH]: VariableMatchNode,
  [NODE_TYPES.IVR_NODE_VARIABLE]: VariableNode,
  [NODE_TYPES.IVR_NODE_VOICEMAIL]: VoicemailNode,
  [NODE_TYPES.START_NODE]: StartNode,
  [NODE_TYPES.IVR_NODE_VOICE_AUTOMATION]: VoiceAutomationNode,
  [NODE_TYPES.IVR_NODE_HANDOFF]: AutomationHandoffNode,
});

export const NODE_COMPONENT_MAPPER = new Proxy(NodeComponents, {
  get: (target, key) => {
    if (key in target) {
      return target[key];
    }
    return GenericNode;
  },
});

export const HTTP_METHODS_OPTIONS = Object.freeze([
  {
    label: 'GET',
    value: 'GET',
  },
  {
    label: 'POST',
    value: 'POST',
  },
]);

export const INPUT_TYPES_OPTIONS = Object.freeze([
  {
    label: 'DTMF',
    value: 'DTMF',
  },
  {
    label: 'SPEECH',
    value: 'SPEECH',
  },
  {
    label: 'DTMF/SPEECH',
    value: 'DTMF_SPEECH',
  },
]);

export const DAYS_OF_THE_WEEK_OPTIONS = Object.freeze(
  DAYS_OF_THE_WEEK.map(dow => ({
    label: dow,
    value: dow,
  }))
);

export const AUTH_TYPES_OPTIONS = Object.freeze([
  { label: 'None', value: '' },
  { label: 'Basic', value: 'Basic' },
]);

export const MESSAGE_TYPES_OPTIONS = Object.freeze([
  {
    label: 'Recording',
    value: MessageType.RECORDING,
  },
  {
    label: 'Text to speech',
    value: MessageType.TEXT,
  },
]);

export const SCHEDULE_TYPES_OPTIONS = Object.freeze([
  {
    label: 'Date',
    value: ScheduleType.SCHEDULE_TYPE_DATE,
  },
  {
    label: 'Days of week',
    value: ScheduleType.SCHEDULE_TYPE_WEEKDAY,
  },
]);

export const CREATE_NEW_NODE = 'create-new-node';
export const NO_VALUE_SELECTED_OPTION = { label: 'None', value: '' };
export const CREATE_NEW_OPTION = {
  label: <CreateNewOptionLabel>Create New Node</CreateNewOptionLabel>,
  value: CREATE_NEW_NODE,
  text: 'Create New Node',
};

export const MATCH_TEXT = 'Match';
export const NO_MATCH_TEXT = 'No match';
export const ERROR_TEXT = 'Error';

export const DESCRIPTION_PLACEHOLDER_TEXT = 'Enter description';
export const DESCRIPTION_LABEL_TEXT = 'Description';
export const NAME_PLACEHOLDER_TEXT = 'Enter name';
